import type { NavItem } from "../../components/ui/BottomNavigation/index.js";

const ProfileIcon = ({ active }: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <circle
      cx="12"
      cy="8"
      r="4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M4 20c0-4 3.582-7 8-7s8 3 8 7"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
export const WhiteChargeIcon = () => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5375 9.75C20.8095 4.6615 16.4335 0.75 11.1435 0.75C5.8535 0.75 1.4785 4.6615 0.75 9.75M12.6435 21.6435C13.4657 21.5255 14.271 21.3103 15.0425 21.0025M9.6435 21.6435C8.81556 21.5255 8.00487 21.3081 7.229 20.996M21.5375 12.75C21.4193 13.5721 21.2039 14.3772 20.896 15.1485M0.75 12.75C0.8695 13.585 1.087 14.389 1.391 15.1485M4.6485 19.5005C3.99173 18.9835 3.39903 18.39 2.883 17.7325M19.4045 17.7325C18.8849 18.3945 18.2876 18.9916 17.6255 19.511"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.517 12.647C8.40188 12.5122 7.29172 12.3391 6.1885 12.128C5.4675 11.988 5.195 11.15 5.686 10.6035C6.942 9.20501 9.189 6.80101 11.621 4.66201C12.266 4.09501 13.2385 4.59201 13.179 5.44901C13.054 7.24751 12.9075 8.71251 12.7715 9.85301C14.1465 10.021 15.276 10.213 16.0995 10.372C16.821 10.512 17.093 11.35 16.6025 11.8965C15.3465 13.2945 13.0995 15.699 10.6675 17.838C10.0225 18.405 9.05 17.908 9.1095 17.051C9.2345 15.2525 9.3805 13.7875 9.517 12.647Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export const ChargeIcon = ({ active, className }: any) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.3939 10.5C21.6659 5.4115 17.2899 1.5 11.9999 1.5C6.70995 1.5 2.33495 5.4115 1.60645 10.5M13.4999 22.3935C14.3222 22.2755 15.1274 22.0603 15.8989 21.7525M10.4999 22.3935C9.67201 22.2755 8.86132 22.0581 8.08544 21.746M22.3939 13.5C22.2757 14.3221 22.0604 15.1272 21.7524 15.8985M1.60645 13.5C1.72595 14.335 1.94345 15.139 2.24745 15.8985M5.50495 20.2505C4.84817 19.7335 4.25548 19.14 3.73945 18.4825M20.2609 18.4825C19.7414 19.1445 19.1441 19.7416 18.4819 20.261"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3725 13.397C9.25734 13.2622 8.14719 13.0891 7.04397 12.878C6.32297 12.738 6.05047 11.9 6.54147 11.3535C7.79747 9.95501 10.0445 7.55101 12.4765 5.41201C13.1215 4.84501 14.094 5.34201 14.0345 6.19901C13.9095 7.99751 13.763 9.46251 13.627 10.603C15.002 10.771 16.1315 10.963 16.955 11.122C17.6765 11.262 17.9485 12.1 17.458 12.6465C16.202 14.0445 13.955 16.449 11.523 18.588C10.878 19.155 9.90547 18.658 9.96497 17.801C10.09 16.0025 10.236 14.5375 10.3725 13.397Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const HomeIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
    <rect
      x="3"
      y="6"
      width="18"
      height="14"
      rx="2"
      stroke="white"
      strokeWidth="1.8"
    />
    <path d="M3 10h18" stroke="white" strokeWidth="1.8" />
    <path d="M8 10V6a4 4 0 018 0v4" stroke="white" strokeWidth="1.8" />
    <rect
      x="9"
      y="14"
      width="6"
      height="4"
      rx="1"
      stroke="white"
      strokeWidth="1.5"
    />
  </svg>
);

const Cart = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.93109 16.6301C3.74109 16.6301 3.55109 16.5601 3.40109 16.4101C3.11109 16.1201 3.11109 15.6401 3.40109 15.3501L15.3511 3.40012C15.6411 3.11012 16.1211 3.11012 16.4111 3.40012C16.7011 3.69012 16.7011 4.17012 16.4111 4.46012L4.46109 16.4201C4.32109 16.5601 4.12109 16.6301 3.93109 16.6301Z" fill="currentColor" />
    <path d="M11.0991 19.03C10.9091 19.03 10.7191 18.96 10.5691 18.81C10.2791 18.52 10.2791 18.04 10.5691 17.75L11.7691 16.55C12.0591 16.26 12.5391 16.26 12.8291 16.55C13.1191 16.84 13.1191 17.32 12.8291 17.61L11.6291 18.81C11.4891 18.95 11.2991 19.03 11.0991 19.03Z" fill="currentColor" />
    <path d="M13.7905 16.3399C13.6005 16.3399 13.4105 16.2699 13.2605 16.1199C12.9705 15.8299 12.9705 15.3499 13.2605 15.0599L15.6505 12.6699C15.9405 12.3799 16.4205 12.3799 16.7105 12.6699C17.0005 12.9599 17.0005 13.4399 16.7105 13.7299L14.3205 16.1199C14.1805 16.2599 13.9805 16.3399 13.7905 16.3399Z" fill="currentColor" />
    <path d="M11.0989 22.7499C10.1189 22.7499 9.13894 22.1499 7.94894 20.9599L3.03894 16.0499C0.648937 13.6599 0.658937 12.1199 3.06894 9.70991L9.70894 3.06991C12.1189 0.659914 13.6589 0.649914 16.0489 3.03991L20.9589 7.94991C23.3489 10.3399 23.3389 11.8799 20.9289 14.2899L14.2889 20.9299C13.0789 22.1399 12.0889 22.7499 11.0989 22.7499ZM12.8989 2.74991C12.3789 2.74991 11.7189 3.17991 10.7689 4.12991L4.12894 10.7699C3.17894 11.7199 2.74894 12.3799 2.74894 12.8899C2.74894 13.4099 3.14894 14.0399 4.09894 14.9899L9.00894 19.8999C9.95894 20.8499 10.5789 21.2499 11.0989 21.2499C11.0989 21.2499 11.0989 21.2499 11.1089 21.2499C11.6289 21.2499 12.2789 20.8199 13.2289 19.8699L19.8689 13.2299C20.8189 12.2799 21.2489 11.6199 21.2489 11.1099C21.2489 10.5899 20.8489 9.95991 19.8989 9.00991L14.9889 4.09991C14.0489 3.14991 13.4189 2.74991 12.8989 2.74991Z" fill="currentColor" />
    <path d="M22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22C22.75 22.41 22.41 22.75 22 22.75Z" fill="currentColor" />
  </svg>

);

const FinanceIcon = ({ active }: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect
      x="2"
      y="6"
      width="20"
      height="14"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path d="M2 10h20" stroke="currentColor" strokeWidth="1.8" />
    <rect x="5" y="13" width="4" height="2" rx="0.5" fill="currentColor" />
    <rect x="11" y="13" width="3" height="2" rx="0.5" fill="currentColor" />
  </svg>
);

const ServicesIcon = ({ active }: any) => (
  <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.75 8.75V4.75C12.75 3.68913 12.3286 2.67172 11.5784 1.92157C10.8283 1.17143 9.81087 0.75 8.75 0.75C7.68913 0.75 6.67172 1.17143 5.92157 1.92157C5.17143 2.67172 4.75 3.68913 4.75 4.75V8.75M1.75 6.75H15.75L16.75 18.75H0.75L1.75 6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ShopIcon = ({ active }: any) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.75 3.75H2.75C2.21957 3.75 1.71086 3.96071 1.33579 4.33579C0.960714 4.71086 0.75 5.21957 0.75 5.75V14.75C0.75 15.2804 0.960714 15.7891 1.33579 16.1642C1.71086 16.5393 2.21957 16.75 2.75 16.75H16.75C17.2804 16.75 17.7891 16.5393 18.1642 16.1642C18.5393 15.7891 18.75 15.2804 18.75 14.75V5.75C18.75 5.21957 18.5393 4.71086 18.1642 4.33579C17.7891 3.96071 17.2804 3.75 16.75 3.75H11.75M7.75 3.75V2.75C7.75 2.21957 7.96071 1.71086 8.33579 1.33579C8.71086 0.960714 9.21957 0.75 9.75 0.75C10.2804 0.75 10.7891 0.960714 11.1642 1.33579C11.5393 1.71086 11.75 2.21957 11.75 2.75V3.75M7.75 3.75C7.75 4.28043 7.96071 4.78914 8.33579 5.16421C8.71086 5.53929 9.21957 5.75 9.75 5.75C10.2804 5.75 10.7891 5.53929 11.1642 5.16421C11.5393 4.78914 11.75 4.28043 11.75 3.75M6.75 11.75C7.28043 11.75 7.78914 11.5393 8.16421 11.1642C8.53929 10.7891 8.75 10.2804 8.75 9.75C8.75 9.21957 8.53929 8.71086 8.16421 8.33579C7.78914 7.96071 7.28043 7.75 6.75 7.75C6.21957 7.75 5.71086 7.96071 5.33579 8.33579C4.96071 8.71086 4.75 9.21957 4.75 9.75C4.75 10.2804 4.96071 10.7891 5.33579 11.1642C5.71086 11.5393 6.21957 11.75 6.75 11.75ZM6.75 11.75C8.056 11.75 9.167 12.585 9.58 13.75M6.75 11.75C6.12938 11.7498 5.52397 11.9421 5.01715 12.3002C4.51032 12.6584 4.12701 13.1649 3.92 13.75M12.75 8.75H15.75M12.75 12.75H14.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const User = ({ active }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.05025 16.0503C8.36301 14.7375 10.1435 14 12 14C13.8565 14 15.637 14.7375 16.9497 16.0503C18.2625 17.363 19 19.1435 19 21H5C5 19.1435 5.7375 17.363 7.05025 16.0503Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Shopping_Cart = ({ active }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 3H5L5.4 5M5.4 5H21L17 13H7M5.4 5L7 13M7 13L4.707 15.293C4.077 15.923 4.523 17 5.414 17H17M17 17C16.4696 17 15.9609 17.2107 15.5858 17.5858C15.2107 17.9609 15 18.4696 15 19C15 19.5304 15.2107 20.0391 15.5858 20.4142C15.9609 20.7893 16.4696 21 17 21C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19C19 18.4696 18.7893 17.9609 18.4142 17.5858C18.0391 17.2107 17.5304 17 17 17ZM9 19C9 19.5304 8.78929 20.0391 8.41421 20.4142C8.03914 20.7893 7.53043 21 7 21C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19C5 18.4696 5.21071 17.9609 5.58579 17.5858C5.96086 17.2107 6.46957 17 7 17C7.53043 17 8.03914 17.2107 8.41421 17.5858C8.78929 17.9609 9 18.4696 9 19Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Clipboard_List = ({ active }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15M9 5C9 5.53043 9.21071 6.03914 9.58579 6.41421C9.96086 6.78929 10.4696 7 11 7H13C13.5304 7 14.0391 6.78929 14.4142 6.41421C14.7893 6.03914 15 5.53043 15 5M9 5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H13C13.5304 3 14.0391 3.21071 14.4142 3.58579C14.7893 3.96086 15 4.46957 15 5M12 12H15M12 16H15M9 12H9.01M9 16H9.01"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CustomerIcon = ({ active }: any) => (
  <svg
    width="22"
    height="18"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.75 16.75H20.75V14.75C20.75 14.1265 20.5557 13.5186 20.1941 13.0106C19.8326 12.5027 19.3218 12.12 18.7327 11.9158C18.1437 11.7115 17.5056 11.6959 16.9073 11.871C16.3089 12.0462 15.78 12.4034 15.394 12.893M15.75 16.75H5.75M15.75 16.75V14.75C15.75 14.094 15.624 13.467 15.394 12.893M15.394 12.893C15.0226 11.965 14.3818 11.1695 13.554 10.6091C12.7262 10.0488 11.7496 9.7493 10.75 9.7493C9.75042 9.7493 8.77376 10.0488 7.946 10.6091C7.11825 11.1695 6.47736 11.965 6.106 12.893M5.75 16.75H0.75V14.75C0.750046 14.1265 0.944336 13.5186 1.30586 13.0106C1.66739 12.5027 2.17819 12.12 2.76725 11.9158C3.35632 11.7115 3.99438 11.6959 4.59274 11.871C5.1911 12.0462 5.72003 12.4034 6.106 12.893M5.75 16.75V14.75C5.75 14.094 5.876 13.467 6.106 12.893M13.75 3.75C13.75 4.54565 13.4339 5.30871 12.8713 5.87132C12.3087 6.43393 11.5456 6.75 10.75 6.75C9.95435 6.75 9.19129 6.43393 8.62868 5.87132C8.06607 5.30871 7.75 4.54565 7.75 3.75C7.75 2.95435 8.06607 2.19129 8.62868 1.62868C9.19129 1.06607 9.95435 0.75 10.75 0.75C11.5456 0.75 12.3087 1.06607 12.8713 1.62868C13.4339 2.19129 13.75 2.95435 13.75 3.75ZM19.75 6.75C19.75 7.28043 19.5393 7.78914 19.1642 8.16421C18.7891 8.53929 18.2804 8.75 17.75 8.75C17.2196 8.75 16.7109 8.53929 16.3358 8.16421C15.9607 7.78914 15.75 7.28043 15.75 6.75C15.75 6.21957 15.9607 5.71086 16.3358 5.33579C16.7109 4.96071 17.2196 4.75 17.75 4.75C18.2804 4.75 18.7891 4.96071 19.1642 5.33579C19.5393 5.71086 19.75 6.21957 19.75 6.75ZM5.75 6.75C5.75 7.28043 5.53929 7.78914 5.16421 8.16421C4.78914 8.53929 4.28043 8.75 3.75 8.75C3.21957 8.75 2.71086 8.53929 2.33579 8.16421C1.96071 7.78914 1.75 7.28043 1.75 6.75C1.75 6.21957 1.96071 5.71086 2.33579 5.33579C2.71086 4.96071 3.21957 4.75 3.75 4.75C4.28043 4.75 4.78914 4.96071 5.16421 5.33579C5.53929 5.71086 5.75 6.21957 5.75 6.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// آیکون بیمه / خدمات
const InsuranceIcon = ({ active }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 8.92308V5.23077C4 4.90435 4.12967 4.5913 4.36048 4.36048C4.5913 4.12967 4.90435 4 5.23077 4H8.92308C9.2495 4 9.56255 4.12967 9.79336 4.36048C10.0242 4.5913 10.1538 4.90435 10.1538 5.23077V8.92308C10.1538 9.2495 10.0242 9.56255 9.79336 9.79336C9.56255 10.0242 9.2495 10.1538 8.92308 10.1538H5.23077C4.90435 10.1538 4.5913 10.0242 4.36048 9.79336C4.12967 9.56255 4 9.2495 4 8.92308ZM13.8462 8.92308V5.23077C13.8462 4.90435 13.9758 4.5913 14.2066 4.36048C14.4375 4.12967 14.7505 4 15.0769 4H18.7692C19.0957 4 19.4087 4.12967 19.6395 4.36048C19.8703 4.5913 20 4.90435 20 5.23077V8.92308C20 9.2495 19.8703 9.56255 19.6395 9.79336C19.4087 10.0242 19.0957 10.1538 18.7692 10.1538H15.0769C14.7505 10.1538 14.4375 10.0242 14.2066 9.79336C13.9758 9.56255 13.8462 9.2495 13.8462 8.92308ZM13.8462 18.7692V15.0769C13.8462 14.7505 13.9758 14.4375 14.2066 14.2066C14.4375 13.9758 14.7505 13.8462 15.0769 13.8462H18.7692C19.0957 13.8462 19.4087 13.9758 19.6395 14.2066C19.8703 14.4375 20 14.7505 20 15.0769V18.7692C20 19.0957 19.8703 19.4087 19.6395 19.6395C19.4087 19.8703 19.0957 20 18.7692 20H15.0769C14.7505 20 14.4375 19.8703 14.2066 19.6395C13.9758 19.4087 13.8462 19.0957 13.8462 18.7692ZM4 18.7692V15.0769C4 14.7505 4.12967 14.4375 4.36048 14.2066C4.5913 13.9758 4.90435 13.8462 5.23077 13.8462H8.92308C9.2495 13.8462 9.56255 13.9758 9.79336 14.2066C10.0242 14.4375 10.1538 14.7505 10.1538 15.0769V18.7692C10.1538 19.0957 10.0242 19.4087 9.79336 19.6395C9.56255 19.8703 9.2495 20 8.92308 20H5.23077C4.90435 20 4.5913 19.8703 4.36048 19.6395C4.12967 19.4087 4 19.0957 4 18.7692Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LoanIcon = ({ active }: any) => (
  <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.24993 7.5625H21.7499M1.66024 8.08715L11.3985 19.6655C11.4693 19.7501 11.5604 19.8186 11.6646 19.8658C11.7689 19.9129 11.8836 19.9374 11.9999 19.9374C12.1162 19.9374 12.2309 19.9129 12.3352 19.8658C12.4395 19.8186 12.5306 19.7501 12.6013 19.6655L22.3396 8.08715C22.4354 7.97287 22.4909 7.83459 22.4989 7.69068C22.5068 7.54677 22.4668 7.40405 22.3841 7.28149L19.0809 2.39379C19.0129 2.29264 18.9178 2.20911 18.8046 2.15112C18.6915 2.09314 18.5641 2.06263 18.4345 2.0625H5.5654C5.43578 2.06263 5.30835 2.09314 5.19522 2.15112C5.08208 2.20911 4.987 2.29264 4.91899 2.39379L1.61571 7.28149C1.53305 7.40405 1.49304 7.54677 1.50099 7.69068C1.50895 7.83459 1.56449 7.97287 1.66024 8.08715Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.75 2.75L16.5 7.5625M16.5 7.5625L12 2.0625L7.5 7.5625M16.5 7.5625L12 19.25L7.5 7.5625M5.25 2.75L7.5 7.5625" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export const ApartemanIcon = ({ active }: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 21V5C19 4.46957 18.7893 3.96086 18.4142 3.58579C18.0391 3.21071 17.5304 3 17 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V21M19 21H5M19 21H21M19 21H14M5 21H3M5 21H10M14 21V16C14 15.7348 13.8946 15.4804 13.7071 15.2929C13.5196 15.1054 13.2652 15 13 15H11C10.7348 15 10.4804 15.1054 10.2929 15.2929C10.1054 15.4804 10 15.7348 10 16V21M14 21H10M9 7H10M9 11H10M14 7H15M14 11H15"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
// آیکون مالی/درآمدزایی
const IncomeIcon = ({ active }: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.1698 22.7501C4.7898 22.7501 2.83984 21.0201 2.83984 18.8901V16.8501C2.83984 16.4401 3.17984 16.1001 3.58984 16.1001C3.99984 16.1001 4.33984 16.4401 4.33984 16.8501C4.33984 18.1001 5.5498 19.0401 7.1698 19.0401C8.7898 19.0401 9.99982 18.1001 9.99982 16.8501C9.99982 16.4401 10.3398 16.1001 10.7498 16.1001C11.1598 16.1001 11.4998 16.4401 11.4998 16.8501V18.8901C11.4998 21.0201 9.5598 22.7501 7.1698 22.7501ZM4.59979 19.8701C5.03979 20.6901 6.0298 21.2501 7.1698 21.2501C8.3098 21.2501 9.29981 20.6801 9.73981 19.8701C9.02981 20.3001 8.1498 20.5501 7.1698 20.5501C6.1898 20.5501 5.30979 20.3001 4.59979 19.8701Z" fill="currentColor" />
    <path d="M7.1698 17.7999C5.5298 17.7999 4.05983 17.0499 3.32983 15.8599C3.00983 15.3399 2.83984 14.7299 2.83984 14.1099C2.83984 13.0599 3.29983 12.0799 4.13983 11.3499C5.75983 9.92992 8.54981 9.92997 10.1798 11.34C11.0198 12.08 11.4898 13.0599 11.4898 14.1099C11.4898 14.7299 11.3198 15.3399 10.9998 15.8599C10.2798 17.0499 8.8098 17.7999 7.1698 17.7999ZM7.1698 11.7499C6.3898 11.7499 5.66982 12.0099 5.12982 12.4799C4.61982 12.9199 4.33984 13.4999 4.33984 14.1099C4.33984 14.4599 4.4298 14.78 4.6098 15.08C5.0698 15.84 6.0498 16.3099 7.1698 16.3099C8.2898 16.3099 9.26979 15.84 9.71979 15.09C9.89979 14.8 9.98981 14.4699 9.98981 14.1199C9.98981 13.5099 9.70983 12.9299 9.19983 12.4799C8.66983 12.0099 7.9498 11.7499 7.1698 11.7499Z" fill="currentColor" />
    <path d="M7.1698 20.55C4.6998 20.55 2.83984 18.96 2.83984 16.86V14.11C2.83984 11.98 4.7798 10.25 7.1698 10.25C8.2998 10.25 9.37982 10.64 10.1898 11.34C11.0298 12.08 11.4998 13.06 11.4998 14.11V16.86C11.4998 18.96 9.6398 20.55 7.1698 20.55ZM7.1698 11.75C5.6098 11.75 4.33984 12.81 4.33984 14.11V16.86C4.33984 18.11 5.5498 19.05 7.1698 19.05C8.7898 19.05 9.99982 18.11 9.99982 16.86V14.11C9.99982 13.5 9.71984 12.92 9.20984 12.47C8.66984 12.01 7.9498 11.75 7.1698 11.75Z" fill="currentColor" />
    <path d="M19.0399 14.7999C17.5299 14.7999 16.2499 13.6799 16.1299 12.2399C16.0499 11.4099 16.3499 10.5999 16.9499 10.0099C17.4499 9.48995 18.1599 9.19995 18.9099 9.19995H20.9999C21.9899 9.22995 22.7499 10.0099 22.7499 10.9699V13.03C22.7499 13.99 21.9899 14.7699 21.0299 14.7999H19.0399ZM20.9699 10.7H18.9199C18.5699 10.7 18.2499 10.8299 18.0199 11.0699C17.7299 11.3499 17.5899 11.7299 17.6299 12.1099C17.6799 12.7699 18.3199 13.2999 19.0399 13.2999H20.9999C21.1299 13.2999 21.2499 13.18 21.2499 13.03V10.9699C21.2499 10.8199 21.1299 10.71 20.9699 10.7Z" fill="currentColor" />
    <path d="M15.9983 21.25H13.4983C13.0883 21.25 12.7483 20.91 12.7483 20.5C12.7483 20.09 13.0883 19.75 13.4983 19.75H15.9983C18.5783 19.75 20.2483 18.08 20.2483 15.5V14.8H19.0383C17.5283 14.8 16.2483 13.68 16.1283 12.24C16.0483 11.41 16.3483 10.6 16.9483 10.01C17.4483 9.49001 18.1583 9.20001 18.9083 9.20001H20.2383V8.5C20.2383 6.16 18.8683 4.54998 16.6483 4.28998C16.4083 4.24998 16.1983 4.25 15.9883 4.25H6.98828C6.74828 4.25 6.51827 4.26999 6.28827 4.29999C4.08827 4.57999 2.73828 6.18 2.73828 8.5V10.5C2.73828 10.91 2.39828 11.25 1.98828 11.25C1.57828 11.25 1.23828 10.91 1.23828 10.5V8.5C1.23828 5.42 3.13832 3.19001 6.08832 2.82001C6.35832 2.78001 6.66828 2.75 6.98828 2.75H15.9883C16.2283 2.75 16.5383 2.76 16.8583 2.81C19.8083 3.15 21.7383 5.39 21.7383 8.5V9.95001C21.7383 10.36 21.3983 10.7 20.9883 10.7H18.9083C18.5583 10.7 18.2383 10.83 18.0083 11.07C17.7183 11.35 17.5783 11.73 17.6183 12.11C17.6683 12.77 18.3083 13.3 19.0283 13.3H20.9983C21.4083 13.3 21.7483 13.64 21.7483 14.05V15.5C21.7483 18.94 19.4383 21.25 15.9983 21.25Z" fill="currentColor" />
  </svg>

);

//ایکون الماس
const diamonds = ({ active }: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.24993 8.25H21.7499M1.66024 8.82235L11.3985 21.4533C11.4693 21.5456 11.5604 21.6203 11.6646 21.6717C11.7689 21.7232 11.8836 21.7499 11.9999 21.7499C12.1162 21.7499 12.2309 21.7232 12.3352 21.6717C12.4395 21.6203 12.5306 21.5456 12.6013 21.4533L22.3396 8.82235C22.4354 8.69768 22.4909 8.54683 22.4989 8.38983C22.5068 8.23284 22.4668 8.07715 22.3841 7.94344L19.0809 2.61141C19.0129 2.50106 18.9178 2.40993 18.8046 2.34668C18.6915 2.28343 18.5641 2.25015 18.4345 2.25H5.5654C5.43578 2.25015 5.30835 2.28343 5.19522 2.34668C5.08208 2.40993 4.987 2.50106 4.91899 2.61141L1.61571 7.94344C1.53305 8.07715 1.49304 8.23284 1.50099 8.38983C1.50895 8.54683 1.56449 8.69768 1.66024 8.82235Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.75 3L16.5 8.25M16.5 8.25L12 2.25L7.5 8.25M16.5 8.25L12 21L7.5 8.25M5.25 3L7.5 8.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const Project = ({ active }: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0004 17.8802C11.7504 17.8802 11.4904 17.7902 11.2904 17.6102L8.71044 15.3502C7.74044 14.5002 7.61044 13.0402 8.42044 12.0302C9.24044 11.0102 10.7004 10.8202 11.7504 11.6102L12.0004 11.8002L12.2604 11.6002C13.3104 10.8102 14.7704 11.0002 15.5904 12.0202C16.4004 13.0302 16.2704 14.4902 15.3004 15.3402L12.7204 17.6002C12.5104 17.7902 12.2504 17.8802 12.0004 17.8802ZM9.69044 14.2202L12.0004 16.2402L14.3104 14.2202C14.6804 13.9002 14.7304 13.3502 14.4204 12.9702C14.1104 12.5802 13.5604 12.5102 13.1604 12.8102L12.4504 13.3402C12.1804 13.5402 11.8204 13.5402 11.5504 13.3402L10.8404 12.8102C10.4504 12.5102 9.89044 12.5802 9.58044 12.9702C9.28044 13.3502 9.33044 13.9002 9.69044 14.2202Z" fill="currentColor" />
    <path d="M17 22.75H7C2.59 22.75 1.25 21.41 1.25 17V7C1.25 2.59 2.59 1.25 7 1.25H8.5C10.25 1.25 10.8 1.82 11.5 2.75L13 4.75C13.33 5.19 13.38 5.25 14 5.25H17C21.41 5.25 22.75 6.59 22.75 11V17C22.75 21.41 21.41 22.75 17 22.75ZM7 2.75C3.42 2.75 2.75 3.43 2.75 7V17C2.75 20.57 3.42 21.25 7 21.25H17C20.58 21.25 21.25 20.57 21.25 17V11C21.25 7.43 20.58 6.75 17 6.75H14C12.72 6.75 12.3 6.31 11.8 5.65L10.3 3.65C9.78 2.96 9.62 2.75 8.5 2.75H7Z" fill="currentColor" />
  </svg>
);

const repots = ({ active }: any) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22C22.75 22.41 22.41 22.75 22 22.75Z" fill="currentColor" />
    <path d="M14.25 22.75H9.75C9.34 22.75 9 22.41 9 22V4C9 2.28 9.95 1.25 11.55 1.25H12.45C14.05 1.25 15 2.28 15 4V22C15 22.41 14.66 22.75 14.25 22.75ZM10.5 21.25H13.5V4C13.5 2.85 12.96 2.75 12.45 2.75H11.55C11.04 2.75 10.5 2.85 10.5 4V21.25Z" fill="currentColor" />
    <path d="M7 22.75H3C2.59 22.75 2.25 22.41 2.25 22V10C2.25 8.28 3.13 7.25 4.6 7.25H5.4C6.87 7.25 7.75 8.28 7.75 10V22C7.75 22.41 7.41 22.75 7 22.75ZM3.75 21.25H6.25V10C6.25 8.75 5.7 8.75 5.4 8.75H4.6C4.3 8.75 3.75 8.75 3.75 10V21.25Z" fill="currentColor" />
    <path d="M21 22.75H17C16.59 22.75 16.25 22.41 16.25 22V15C16.25 13.28 17.13 12.25 18.6 12.25H19.4C20.87 12.25 21.75 13.28 21.75 15V22C21.75 22.41 21.41 22.75 21 22.75ZM17.75 21.25H20.25V15C20.25 13.75 19.7 13.75 19.4 13.75H18.6C18.3 13.75 17.75 13.75 17.75 15V21.25Z" fill="currentColor" />
  </svg>
); export const CameraIcon = ({ active }: any) => (
  <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.75 4.75L17.303 2.474C17.4554 2.39784 17.6248 2.36188 17.795 2.36955C17.9652 2.37721 18.1306 2.42825 18.2756 2.51781C18.4206 2.60736 18.5402 2.73248 18.6233 2.88127C18.7063 3.03007 18.7499 3.19761 18.75 3.368V10.132C18.7499 10.3024 18.7063 10.4699 18.6233 10.6187C18.5402 10.7675 18.4206 10.8926 18.2756 10.9822C18.1306 11.0718 17.9652 11.1228 17.795 11.1305C17.6248 11.1381 17.4554 11.1022 17.303 11.026L12.75 8.75V4.75ZM2.75 12.75H10.75C11.2804 12.75 11.7891 12.5393 12.1642 12.1642C12.5393 11.7891 12.75 11.2804 12.75 10.75V2.75C12.75 2.21957 12.5393 1.71086 12.1642 1.33579C11.7891 0.960714 11.2804 0.75 10.75 0.75H2.75C2.21957 0.75 1.71086 0.960714 1.33579 1.33579C0.960714 1.71086 0.75 2.21957 0.75 2.75V10.75C0.75 11.2804 0.960714 11.7891 1.33579 12.1642C1.71086 12.5393 2.21957 12.75 2.75 12.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// export const CUSTOMER_NAV_ITEMS: NavItem[] = [
//   {
//     id: "services",
//     label: "بیمه",
//     route: "/customer/insurance",
//     Icon: InsuranceIcon,
//   },
//   {
//     id: "finance",
//     label: "وام",
//     route: "/customer/loan",
//     Icon: LoanIcon,
//   },
//   { id: "home", label: "کارت", route: "/customer", Icon: Cart, isCenter: true },
//   {
//     id: "charge",
//     label: "درآمدزایی",
//     route: "/customer/revenues",
//     Icon: IncomeIcon,
//   },
//   {
//     id: "profile",
//     label: "پروفایل",
//     route: "/customer/profile",
//     Icon: ProfileIcon,
//   },
// ];


// ===== آیتم‌های کاربر عادی =====
export const CUSTOMER_NAV_ITEMS: NavItem[] = [
  {
    id: "services",
    label: "خدمات",
    route: "/customer/services",
    Icon: InsuranceIcon,
  },
  {
    id: "finance",
    label: "الماس",
    route: "/customer/loan",
    Icon: LoanIcon,
  },
  { id: "home", label: "کارت", route: "/customer", Icon: Cart, isCenter: true },
  {
    id: "charge",
    label: "همکاری",
    route: "/customer/revenues",
    Icon: IncomeIcon,
  },
  {
    id: "profile",
    label: "پروفایل",
    route: "/customer/profile",
    Icon: ProfileIcon,
  },
];
export const LEGAL_ONLY_NAV_ITEMS: NavItem[] = [
  {
    id: "services",
    label: "خدمات",
    route: "/customer/services",
    Icon: InsuranceIcon,
  },
  {
    id: "finance",
    label: "الماس",
    route: "/customer/loan",
    Icon: LoanIcon,
  },
  { id: "home", label: "کارت", route: "/customer", Icon: Cart, isCenter: true },
  {
    id: "charge",
    label: "همکاری",
    route: "/customer/revenues",
    Icon: IncomeIcon,
  },
  {
    id: "profile",
    label: "پروفایل",
    route: "/customer/profile",
    Icon: ProfileIcon,
  },
];
// ===== آیتم‌های کاربر حقوقی (legal) =====
export const LEGAL_NAV_ITEMS: NavItem[] = [
  {
    id: "services",
    label: "خدمات",
    route: "/customer/services",
    Icon: InsuranceIcon,
  },
  // {
  //   id: "finance",
  //   label: "الماس",
  //   route: "/customer/loan",
  //   Icon: LoanIcon,
  // },
  {
    id: "revenues",
    label: "همکاری",
    route: "/customer/revenues",
    Icon: repots,
  },
  // {
  //   id: "diamonds",
  //   label: "الماس‌ها",
  //   route: "/customer/legal/charity/diamonds",
  //   Icon: diamonds, // ⚠️ آیکون مناسب انتخاب کن
  // },
  { id: "home", label: "کارت", route: "/customer", Icon: Cart, isCenter: true },
  {
    id: "projects",
    label: "پروژه ها",
    route: "/customer/legal/charity/project",
    Icon: Project, // ⚠️ آیکون مناسب انتخاب کن
  },
  {
    id: "profile",
    label: "پروفایل",
    route: "/customer/profile",
    Icon: ProfileIcon,
  },
];
// ===== آیتم‌های خیریه (legal + charity === true) =====
export const CHARITY_NAV_ITEMS: NavItem[] = [
  {
    id: "services",
    label: "خدمات",
    route: "/customer/services",
    Icon: InsuranceIcon,
  },
  {
    id: "revenues",
    label: "همکاری",
    route: "/customer/revenues",
    Icon: repots,
  },
  { id: "home", label: "کارت", route: "/customer", Icon: Cart, isCenter: true },
  {
    id: "projects",
    label: "پروژه ها",
    route: "/customer/legal/charity/project",
    Icon: Project,
  },
  {
    id: "profile",
    label: "پروفایل",
    route: "/customer/profile",
    Icon: ProfileIcon,
  },
];